import React, { memo, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, IconClose, IconButton } from '@redlink/components/atoms';
import Animated, {
  cond,
  eq,
  Extrapolate,
  interpolate,
} from 'react-native-reanimated';
import { useTimingTransition } from 'react-native-redash';

export const PreviewBottomSheet = memo(
  ({ title, isVisible = false, onDismiss, children }) => {
    const { styles, colors } = useStyle();
    const [height, setHeight] = useState(0);

    const progress = useTimingTransition(isVisible);
    const translateY = interpolate(progress, {
      inputRange: [0, 1],
      outputRange: [height, 0],
      extrapolate: Extrapolate.CLAMP,
    });
    const opacity = interpolate(progress, {
      inputRange: [0, 0.3, 1],
      outputRange: [0, 0.1, 1],
      extrapolate: Extrapolate.CLAMP,
    });
    const pointerEvents = cond(eq(progress, 1), 'auto', 'none');

    const _containerOnLayout = ({
      nativeEvent: {
        layout: { height: h },
      },
    }) => setHeight(h);

    return (
      <Animated.View
        style={[styles.container, { opacity }]}
        pointerEvents={pointerEvents}
      >
        <Animated.View
          style={[styles.bodyContainer, { transform: [{ translateY }] }]}
          onLayout={_containerOnLayout}
        >
          <View style={styles.headerContainer}>
            <Text style={styles.headerText}>{title}</Text>
            <IconButton style={styles.closeIconContainer} onPress={onDismiss}>
              <IconClose size={24} color={colors.background} />
            </IconButton>
          </View>
          <Space />
          {children}
        </Animated.View>
      </Animated.View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow, applyAlpha }) => ({
  container: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: applyAlpha(colors.black, 0.7),
    justifyContent: 'flex-end',
  },
  bodyContainer: {
    backgroundColor: colors.background,
    padding: 24,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    borderTopWidth: 1,
    borderTopColor: applyAlpha(colors.title, 0.5),
  },
  closeIconContainer: {
    backgroundColor: colors.title,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    color: colors.subtitle,
    fontSize: 14,
    flex: 1,
  },
}));
